import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, Loader } from "semantic-ui-react";
import { getHomeDrawRequestsInfolist } from "../../../api/BorrowerApi";
import { getMockHomeDrawRequestsInfolist } from "../../../api/mock/MockBorrowerApi";
import { IProxyUser } from "../../interfaces/Global";
import BCEmptyState from "../../ui/BCEmptyState";
import "../../../styles/borrower/home.scss";
import BWDrawRequestCard from "./BWDrawRequestCard";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import BCConfirmationModal from "../../ui/BCConfirmationModal";

interface IBWDrawRequestsContent {
  isApiMessage: string[];
  setIsApiMessage: React.Dispatch<React.SetStateAction<string[]>>;
  isGreaterThanTablet: boolean;
  proxyUser: IProxyUser | undefined;
  includeFundedDraws: boolean;
  deleteLoanDrawRequestAsync: (loanDrawRequestId: string) => Promise<void>;
}

const BWDrawRequestsContent = ({
  isApiMessage,
  setIsApiMessage,
  isGreaterThanTablet,  
  proxyUser,
  includeFundedDraws,
  deleteLoanDrawRequestAsync
} : IBWDrawRequestsContent) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [drawRequestsInfoData, setDrawRequestsInfoData] = useState(undefined as any);
  const [isDeleteDrawModalOpen, setIsDeleteDrawModalOpen] = useState(false as boolean);
  const [selectedLoanDrawId, setSelectedLoanDrawId] = useState("" as string);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const filterDraws = (requests) => {
    const nonFundedDraws = requests.filter(request => request.loanDrawApplicationStatus !== "Funded").slice(0,6);
    if (includeFundedDraws) {
      return [...requests].slice(0,6);
    } 
    
    return nonFundedDraws;
  };

  const handleDeleteLoanDrawRequest = async () => {
    setIsLoading(true);
    setIsDeleteDrawModalOpen(false);
    setDrawRequestsInfoData(drawRequestsInfoData.filter(draw => draw.id !== selectedLoanDrawId));
    await deleteLoanDrawRequestAsync(selectedLoanDrawId);
    setIsLoading(false);
  };

  useEffect(() => {
    const getDrawRequestsInfoAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockHomeDrawRequestsInfolist() : await getHomeDrawRequestsInfolist(proxyUser && proxyUser.id);
        if (response && response.ok) {
          const drawRequestsInfo = await response.json();
          setDrawRequestsInfoData(drawRequestsInfo);
        }
        else {
          FeatureFlags.IS_DEBUG && console.log("Draw Requests response:");
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage([...isApiMessage, "Draw Requests"]);
        }
      }
      catch (error) {
        handleError();
      }
      
      setIsLoading(false);
    };

    getDrawRequestsInfoAsync();
  }, [handleError, proxyUser]);
    
  return (
    <React.Fragment>
      <BCConfirmationModal
        isModalOpen={isDeleteDrawModalOpen}
        setIsModalOpen={setIsDeleteDrawModalOpen}
        modalHeader="Delete loan draw request?"
        modalContent="Loan Draw request will be deleted"
        handleConfirm={handleDeleteLoanDrawRequest}
      />
      {isLoading ? <div className="borrower-home-loader"><Loader active inline="centered" size="big" /></div> : 
        <React.Fragment>
          {drawRequestsInfoData && filterDraws(drawRequestsInfoData).length > 0 ? <Card.Group itemsPerRow={isGreaterThanTablet ? 3 : 1}>
            {filterDraws(drawRequestsInfoData).map((drawReqest, i) => <BWDrawRequestCard drawRequest={drawReqest} index={i} setIsDeleteDrawModalOpen={setIsDeleteDrawModalOpen} setSelectedLoanDrawId={setSelectedLoanDrawId}/>)}
          </Card.Group>
          : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon="clipboard outline"
              text="You currently have no loan draw applications"
              content="Starting a loan draw application will create a new loan draw application tile in this section. Any unfinished loan draw applications can be resumed here"
            />
          }
        </React.Fragment>
      }
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(drawRequestsInfoData)}>drawRequestsInfoData</button>
        <button onClick={() => console.log(drawRequestsInfoData.filter(request => request.loanDrawApplicationStatus !== "Funded"))}>FundedDrawRequestsInfoData</button>
        <button onClick={() => console.log(includeFundedDraws)}>includeFundedDraws</button>
      </React.Fragment>}
    </React.Fragment>
  );
};

export default BWDrawRequestsContent;